<template>
    <div class="a-table__head-cell">
        <label class="a-table-switcher">
            <input
                class="a-table-switcher__input"
                type="checkbox"
                :checked="modelValue"
                @change="$emit('update:modelValue', $event.target.checked)"
            />
            <span class="a-table-switcher__text">{{ text }}</span>
            <span class="a-table-switcher__decor" :aria-hidden="true" />
        </label>
    </div>
</template>

<script setup>
defineOptions({
    name: 'STableHeadSwitcher',
});

defineProps({
    modelValue: {
        type: Boolean,
        default: true,
    },
    text: {
        type: String,
        required: true,
    },
});

defineEmits(['update:modelValue']);
</script>

<style lang="postcss" scoped>
.a-table-switcher {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.a-table-switcher__input {
    position: absolute;
    visibility: hidden;
}

.a-table-switcher__input:checked ~ .a-table-switcher__decor {
    background-color: var(--av-fixed-success);
}

.a-table-switcher__input:checked ~ .a-table-switcher__decor::after {
    transform: translate(17px, -50%);
}

.a-table-switcher__text {
    @mixin paragraph;

    display: inline-block;
    position: relative;
    margin-inline-end: 16px;
    color: var(--av-fixed-secondary);
}

.a-table-switcher__decor {
    position: relative;
    flex: 0 0 37px;
    height: 22px;
    border-radius: 100px;
    background-color: var(--av-brand-light);
    transition: background-color 0.15s ease-out;
}

.a-table-switcher__decor::after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    inset-inline-start: 2px;
    width: 16px;
    border-radius: 100px;
    height: 16px;
    background-color: var(--av-inversed-primary);
    transition: transform 0.25s ease-out;
}
</style>
